import {getDefatultIndicatorValues} from '../../utils/biomarkers'

const getSubjectId = () => {
    return window.location.pathname.split('/').filter(it => it)[0];
}
export const getThemeId = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('theme');
}

export const getHash = () => {
    return (window.location.search || '').replace('&=undefined', '')
}

export const _initHash = (obj) => {
    return '?' + Object.keys(obj).map(key => {
        return `${key}=${obj[key]}`
    }).join('&')
    
}
export function simplifyHash(str) {
    return (str || '')
        .replace('&=undefined', '')
        .replace('=undefined', '')
}
export const getUrl = (url, _obj) => {
    url = url || ''
    let hash = _initHash({...getHashObj(), ..._obj});
    let obj = getDefatultIndicatorValues()


    obj = {...obj || {}, ..._obj || {}}

    if (/summary/gi.test(url)) {
        if (obj.theme) {
            return simplifyHash(('/theme/' + obj.theme).replace('//', '/').replace(/\/$/gi, '') + (hash || _initHash(obj)));
        } else {
            return simplifyHash(('/home') + hash);
        }
    }
    return simplifyHash(('/' + url)
        .replace('//', '/')
        .replace(/\/$/gi, '') + hash);
}

export const getHashObj = () => {
    return getHash().replace('#', '').replace('?', '').split('&').reduce((acc, it) => {
        let arr = it.split('=')
        return {...acc, [arr[0]]: arr[1] == +arr[1] ? +arr[1] : arr[1]}
    }, {})
}
export default getSubjectId;